module.exports = __webpack_public_path__ + "img/list-ol.b6b6e44d.svg";